// @flow

import classnames from 'classnames';
import React from 'react';

import { Button } from 'seek-style-guide/react';
import SaveJob from 'src/components/SaveJob/SaveJob';

import buttonsStyles from '../../JobActionButtons.less';
import styles from './SaveJobButton.less';

type Props = {
  job: ChaliceJobDetail
};

const SaveJobButton = ({ job }: Props) => (
  <SaveJob
    buttonCopy={{
      saved: 'Saved job',
      unsaved: 'Save job'
    }}
    color="gray"
    component={Button}
    job={job}
    className={classnames(buttonsStyles.hackWrap, styles.saveJobButton)}
    fullWidth
  />
);

SaveJobButton.defaultProps = {
  className: ''
};

export default SaveJobButton;
